@if (consumer) {
<div class="contact-page">
    <div class="header-section">
        <div class="header">
            <h1 class="theme-heading">{{ 'UserManagement' | translate }}</h1>
            <por-base-button [featureName]="'contact-close'" (click)="onCloseButtonClick()" icon="close"></por-base-button>
        </div>
    </div>
    <div class="content-wrapper" porAddFeature featureName="aggridheader">
        <div class="filters">
            <por-filters [initFilters]="initFilters" [multiFilters]="filterValues" [enableSearchBox]="false" [enableDateSearchBox]="false" (filterOutput)="filter($any($event))"></por-filters>
            <div class="search-actions">
                <div class="alert alert-info contacts-info-alert" role="alert">{{ 'Contacts.RegistrationInfo' | translate }}</div>
                <por-search-box featureName="contacts-quick-search" (searched)="onQuickFilterChange($event)"></por-search-box>
                <por-base-button [class]="'theme-button'" [featureName]="'add-contact'" (click)="onAddContactClick($event)">{{ 'AddContact.ButtonText' | translate }}</por-base-button>
                <por-base-button [class]="'theme-button'" [featureName]="'manage-default-permissions'" (click)="openDefaultPermissionsModal()">
                    {{ 'DefaultPermissions.ManageButton' | translate }}
                </por-base-button>
            </div>
        </div>
        <ag-grid-angular
            style="width: 100%; height: 100%"
            class="ag-theme-alpine ag-grid"
            [defaultColDef]="defaultColDef"
            [columnDefs]="columnDefs"
            [rowData]="filteredContacts()"
            [gridOptions]="gridOptions"
            [rowHeight]="65"
            [headerHeight]="50"
            (gridReady)="onGridReady($event)"
            [context]="context"
            [quickFilterText]="quickFilterText" />
    </div>
</div>
<por-default-permissions-modal [customerId]="customerId"></por-default-permissions-modal>
<por-add-contact-modal [customerId]="customerId"></por-add-contact-modal>
}
